const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-96">
      <h1 className="text-4xl font-bold text-gray-900">404</h1>
      <p className="text-gray-600 mt-2">Page non trouvée</p>
    </div>
  )
}

export default NotFoundPage
